import { create } from 'zustand';

/** Replaces `WorkspaceService`. The service line the toolbar's region picker selects. */

export type WorkspaceRegion = 'AMER' | 'EMEA' | 'APAC';

export interface Workspace {
  id: WorkspaceRegion;
  label: string;
  description: string;
}

const STORAGE_KEY = 'activeWorkspace';

export const WORKSPACES: Workspace[] = [
  { id: 'AMER', label: 'AMER', description: 'Americas service line' },
  { id: 'EMEA', label: 'EMEA', description: 'Europe, Middle East & Africa service line' },
  { id: 'APAC', label: 'APAC', description: 'Asia Pacific service line' }
];

function readStored(): WorkspaceRegion {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (stored === 'AMER' || stored === 'EMEA' || stored === 'APAC') {
      return stored;
    }
  } catch {
    // localStorage unavailable (e.g. private browsing)
  }

  return 'AMER';
}

export interface WorkspaceState {
  workspace: WorkspaceRegion;
  workspaces: Workspace[];
  setWorkspace: (id: WorkspaceRegion) => void;
}

export const useWorkspaceStore = create<WorkspaceState>((set, get) => ({
  workspace: readStored(),
  workspaces: WORKSPACES,

  setWorkspace: (id) => {
    if (id === get().workspace) {
      return;
    }

    set({ workspace: id });

    try {
      localStorage.setItem(STORAGE_KEY, id);
    } catch {
      // selection just won't persist across reloads
    }
  }
}));

/** The full `Workspace` record for the active region, not just its id. */
export function useActiveWorkspace(): Workspace {
  const workspace = useWorkspaceStore((state) => state.workspace);

  return WORKSPACES.find((entry) => entry.id === workspace) ?? WORKSPACES[0];
}
